import types from '../../constants';
import auth from '../../auth';
import helpers from '../../helpers';

export function fetchScenario(scenarioId) {
  const user = helpers.getUserFromLocalStorage();
  if (!user) return auth.logoutAndRedirect();

  const companyId = user.company._id;

  return async (dispatch) => {
    dispatch({ type: types.SCENARIO_FETCH_START });

    fetch(`/api/scenarios/${companyId}/${scenarioId}`, {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          throw new Error('Not authenticated.');
        }

        return response.json();
      })
      .then((data) => {
        dispatch({
          type: types.SCENARIO_FETCH_END,
          payload: data.scenario,
        });
      })
      .catch(err => console.log('err!', err)); // eslint-disable-line

    return true;
  };
}

export function updateScenario(values) {
  return async (dispatch) => {
    dispatch({
      type: types.SCENARIO_UPDATE,
      payload: values
    })
  }
}

export function saveScenarioChanges(scenarioId, changes) {
  return async (dispatch) => {
    const user = helpers.getUserFromLocalStorage();
    if (!user) return auth.logoutAndRedirect();

    // let formData = new FormData();
    //
    // Object.keys(changes).map(key => formData.append(key, changes[key]));

    const companyId = user.company._id;

    return fetch(`/api/scenarios/${companyId}/${scenarioId}/edit`, {
      method: 'PUT',
      body: JSON.stringify(changes),
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
        'Content-Type': 'application/json'
      },
    })

  }
}
